<template>
  <v-dialog
    style="box-shadow: none !important"
    v-model="dialog"
    persistent
    max-width="500"
  >
    <v-card class="pb-2">
      <v-toolbar color="primary">
        <v-card-title class="text-h5 white--text">
          Percentual Rateio
        </v-card-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal()">
          <v-icon color="white"> mdi-close</v-icon></v-btn
        >
      </v-toolbar>
      <v-form class="pa-5">
        <v-autocomplete
          :items="itemsEmpresas"
          item-text="sigla"
          item-value="sigla"
          v-model="itemEmpresa"
          label="Empresa"
          dense
          :loading="loading"
          return-object
        >
          <template v-slot:no-data>
            <div class="px-4 py-2 font-weight-medium subtitle-2">
              Não há dados disponíveis
            </div>
          </template>
        </v-autocomplete>
      </v-form>
      <v-card-text class="pa-3">
        <!-- <BaseDataTable
          :headers="headers"
          :items="itemsConsultaPercentual"
          @pageChange="fetchConsultaPercetualRateioPadrao({ page: $event })"
          :paginate="true"
          :currentPage="currentPage"
          :lastPage="lastPage"
          :loading="loading"
          class="mt-4"
        >
          <template v-slot:item.descricao_produto="{ item }">
            {{ formatText(item.descricao_produto) }}
          </template>
        </BaseDataTable> -->
        <v-card
          class="mb-2 pa-0"
          v-for="(item, x) in itemsConsultaPercentual"
          :key="x"
          color="#385F73"
          dark
        >
          <v-card-title class="text-h6 pb-0">
            <v-toolbar color="primary" elevation="0" dense>
              Empresa: {{ item.apelido }}
            </v-toolbar>
          </v-card-title>

          <v-card-text class="bg-error">
            <div style="background-color: darkgray" class="pa-4 pb-1 bg-error">
              <v-row>
                <v-col class="d-flex pa-1" cols="12">
                  <p class="text-bold mr-1 card-list-text">Descrição:</p>
                  <p class="card-list-text">
                    {{ item.descricao }}
                  </p>
                </v-col>

                <v-col cols="12" class="d-flex pa-1 ma-">
                  <p class="text-bold mr-1 card-list-text">Percentual:</p>
                  <p class="card-list-text">{{ item.percentual }}%</p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="mx-2">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          class="white--text btn-form"
          color="error"
          @click="closeModal()"
        >
          FECHAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import empresas from "../../../../services/http/empresas";
import ConsultaPercentual from "../../../../services/http/nfeNcm/ConsultaPercentual";
// import BaseDataTable from "@/components/BaseDataTable.vue";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    selectedItem: {
      type: Object,
    },
  },
  components: {
    // BaseDataTable,
  },
  data() {
    return {
      loading: false,
      itemsConsultaPercentual: [],
      itemsEmpresas: [],
      filter: {},
      currentPage: 1,
      lastPage: 1,
      selectStatus: {},
      itemEmpresa: undefined,
      status: [
        { text: "Ativo", value: true },
        { text: "Inativo", value: false },
      ],
      headers: [
        {
          text: "Empresa",
          value: "apelido",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "Código Contábil",
          value: "cod_contabil",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "Percentual",
          value: "percentual",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ],
    };
  },

  watch: {
    selectedItem() {
      this.itemEmpresa = undefined;
      this.fetchConsultaPercetualRateioPadrao();
      this.fetchEmpresas();
    },
    itemEmpresa(value) {
      this.fetchConsultaPercetualRateioPadrao({
        apelido: value.sigla,
        page: this.currentPage,
      });
    },
  },

  methods: {
    async fetchConsultaPercetualRateioPadrao(filters = {}) {
      this.loading = true;
      try {
        let { data } = await ConsultaPercentual().show({
          cod_contab_padrao: this.selectedItem.cod_contab_padrao,
          schema_nbs: this.selectedItem.schema_nbs,
          cod_contabil: this.selectedItem.cod_contabil,
          per_page: -1,

          ...filters,
        });
        this.itemsConsultaPercentual = data.data;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async fetchEmpresas() {
      try {
        let { data } = await empresas().show({
          per_page: -1,
          segmento_id: [1, 2],
        });
        this.itemsEmpresas = data.data;
      } catch (e) {
        console.log(e);
      }
    },

    clearable() {},

    closeModal() {
      this.$emit("update:dialog", false);
    },
  },
};
</script>
<style scoped>
.magin-text {
  margin: 100px 0;
}
.v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 10px;
}

.card-list-text {
  color: black;
  font-weight: bold;
  font-size: 1rem;
}
</style>
